import { t } from "@lingui/macro";
import { CruiseItineraryFragment, Maybe } from "types/graphql-types";

export const isRealPort = (portCode: string | undefined | null): boolean => {
  if (!portCode) return false;
  return !portCode.startsWith("ZZ");
};

export const getGeoAreaStats = (
  itinerary: (CruiseItineraryFragment | undefined)[]
): { portsCount: number; countriesCount: number } => {
  const stats = itinerary.reduce(
    (acc, i) => {
      const port = i?.port;
      if (!port || !isRealPort(port.data?.code)) return acc;

      const { ports, countries } = acc;
      const country = port.region?.country || port.data?.country;

      ports.add(port?.data?.code);
      countries.add(country?.isoAlpha2Code);
      return { ports, countries };
    },
    { ports: new Set(), countries: new Set() }
  );

  return {
    portsCount: stats.ports.size,
    countriesCount: stats.countries.size
  };
};

interface SuiteSortCategory {
  category?: {
    order?: number;
  };
}

export const sortSuites = <T extends SuiteSortCategory[]>(suites: T): T => {
  return suites.sort(
    (a, b) => (a?.category?.order || 0) - (b?.category?.order || 0)
  );
};

export const buildCruiseName = (
  cruise: Partial<{
    data?: Maybe<{
      departurePort?: Maybe<{
        data?: Maybe<{ name?: Maybe<{ localized?: Maybe<string> }> }>;
      }>;
      arrivalPort?: Maybe<{
        data?: Maybe<{ name?: Maybe<{ localized?: Maybe<string> }> }>;
      }>;
    }>;
  }>
): string => {
  if (!cruise) return "";

  return `${
    cruise?.data?.departurePort?.data?.name?.localized
  } ${t`port-to-port`} ${cruise?.data?.arrivalPort?.data?.name?.localized}`;
};
